import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { Languages } from 'src/app/shared/models/enums.model';
import { SupplierRegistrationComponent } from 'src/app/front-user/services/e-tender/supplier-registration/supplier-registration.component';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import { User } from 'src/app/front-user/shared/models/user.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { SupplierService } from 'src/app/shared/services/supplier.service';
import { SupplierRegistrationActivationDTO } from 'src/app/shared/models/e-tender.model';
import { AppConfig } from 'src/app/shared/services/app.config';

@Component({
  selector: 'app-supplier-registration-activate',
  templateUrl: './supplier-registration-activate.component.html',
  styles: []
})
export class SupplierRegistrationActivateComponent implements OnInit, AfterViewInit {
  //#region PROPERTIES
  /////////////////////*Input - Outputs -ViewChild*/////////////////////
  @ViewChild('supplierChild',{static: false}) supplierChild: SupplierRegistrationComponent;
  /////////////////////*Language*/////////////////////
  public Languages: any = Languages;
  public currentLanguage: any;
  isSubmitSucceeded: boolean = false;
  public selectedSupplierId: string;
  private currentUser: User = new User();
  wfAppInstanceId: string;
  baseRequestId: string;
  categoryId: string;
  private responseObj: ResponseObject = new ResponseObject();
  private supplierRegistrationActivationDTO: SupplierRegistrationActivationDTO = new SupplierRegistrationActivationDTO();
  public submitFail: boolean = false;
  private myTasksUrl: string;
  public isRequestHistory: boolean = false;
  private isInActivateStepInput: boolean = false;
  public isTaskCompletedByAnotherUser: boolean = false;
  //#endregion
  //#region CONSTRUCTOR
  constructor(private globalServices: GlobalServices,
    private supplierService: SupplierService,
    private router: Router,
    private activatedRoute: ActivatedRoute,

  ) {
    this.isInActivateStepInput = true;
    this.currentLanguage = this.globalServices.getLanguage();
    this.currentUser = this.globalServices.user;
    if (this.currentLanguage == Languages.English) {
      // this.myTasksUrl = "/English/Pages/Workspace.aspx#/myTasks";
      this.myTasksUrl = "/English" + AppConfig.settings.apiServer.RelativeIndexPageUrl + "myTasks";
    } else {
      // this.myTasksUrl = "/Arabic/Pages/Workspace.aspx#/myTasks";
      this.myTasksUrl = "/Arabic" + AppConfig.settings.apiServer.RelativeIndexPageUrl + "myTasks";
    }

    if (history.state.data) {
      if (history.state.data.requestId) {
        this.selectedSupplierId = history.state.data.requestId;
        //TODO: Get the AppInistanceID_CategoryID from MyTasks to be sent as InPut in approval Component
        //TODO: Get [AppInstanceID-CategoryId] -  from my tasks as "BaseRequestID_CategoryID"
        this.wfAppInstanceId = history.state.data.appInstanceId;
        var splits = this.wfAppInstanceId.split("_")
        this.baseRequestId = splits[0];
        this.categoryId = splits[1];
        this.supplierRegistrationActivationDTO.AdminEmail = this.currentUser.UserName;
        this.supplierRegistrationActivationDTO.SupplierId = this.selectedSupplierId;
        this.supplierRegistrationActivationDTO.WFAppInstanceID = this.wfAppInstanceId;
      }
      if (history.state.data.isCompleted) {
        this.isRequestHistory = history.state.data.isCompleted;
      }
    }
    else {
      // this.globalServices.goToHome();
      // this.router.navigate(['RebateRequest/AccurateDataForm'], { state: { data: { requestId: this.rebateRequestId } } });
      //   this.selectedSupplierId = "E26FBBE8-7677-4C85-83D2-DD2C54894ADF"
      //   this.wfAppInstanceId = "d58c27d2-3c7f-4fb4-ac6a-35ac78bc1713_1";
      //   var splits = this.wfAppInstanceId.split("_")
      //   this.baseRequestId = splits[0];
      //   this.categoryId = splits[1];
      //   this.supplierRegistrationActivationDTO.AdminEmail = "Abdelrahman.shafik@linkdev.com";
      //   this.supplierRegistrationActivationDTO.SupplierId = this.selectedSupplierId;
      //   this.supplierRegistrationActivationDTO.WFAppInstanceID = this.wfAppInstanceId;
    }
  }
  //#endregion
  //#region EVENTS
  ngOnInit() {
  }
  ngAfterViewInit(): void {

  }
  //#endregion
  //#region FUNCTIONS
  submit(): void {
    this.globalServices.isLoaderEnabled = true;
    this.submitSupplierRegistrationActivation();

  }
  submitSupplierRegistrationActivation(): void {
    this.supplierService.SubmitSupplierRegistrationActivation(this.supplierRegistrationActivationDTO).subscribe(
      data => this.responseObj = data,
      () => this.submitFail = true,
      () => this.submitSupplierRegistrationActivationCompleted()
    );
  }
  submitSupplierRegistrationActivationCompleted(): void {
    if (this.responseObj.Success) {
      //Enable Confirmation
      this.isSubmitSucceeded = true;
    } else {
      this.isTaskCompletedByAnotherUser = this.responseObj.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null ? true : false;
      if (this.isTaskCompletedByAnotherUser) {
        this.isSubmitSucceeded = true;
      } else {
        this.submitFail = true;
      }
    }
    //Disable Loader
    this.globalServices.isLoaderEnabled = false;
  }
  //#endregion
}
